import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { getManager, Repository } from "typeorm";
import { DeheadingRatesEntity } from "./deheading-rates-entity";
import { DeheadingratesDTO } from "./dto/deheading-rates.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import appSettings from "apps/services/config";

@Injectable()
export class DeheadingRatesService {
    constructor(
        @InjectRepository(DeheadingRatesEntity) private deheadingRatesRepository: Repository<DeheadingRatesEntity>
    ) { }

    private readonly DeheadingRatesColumns = [
        "SNo", "ContractorName", "COUNT", "BILLTYPE", "RATE"
    ];

    async saveDeheadingRatesInfo(formData: any): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
            const updatedArray = formData.data.map((obj: any) => {
                const updatedObj: any = {};
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });
    
            const difference = columnArray.filter((element) => !this.DeheadingRatesColumns.includes(element));
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 1110, "Excel columns don't match. Please attach the correct file.");
            }
    
            const convertedData = updatedArray.map((obj: any) => {
                const updatedObj: any = {};
                for (const key in obj) {
                    const value = obj[key];
                    updatedObj[key] = value === "" ? null : value;
                }
                return updatedObj;
            });
    
            const manager = getManager();
    
            for (const data of convertedData) {
                // Get contractor ID
                const query = `select c.contractor_id as contractorId from ${appSettings.hrms_db}.contractor c where c.contractor_name ='${data.ContractorName}'`;
                const contractor = await manager.query(query);
    
                if (!contractor || !contractor[0]?.contractorId) {
                    flag.add(false);
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 0, `Contractor ${data.ContractorName} not found`);
                }
    
                const contractorId = contractor[0].contractorId;
    
                const existingEntry = await transactionManager
                    .getRepository(DeheadingRatesEntity)
                    .findOne({
                        where: {
                            contractorId: contractorId,
                            billType: data.BILLTYPE,
                            count: data.COUNT,
                        },
                    });
    
                if (existingEntry) {
                    existingEntry.rate = data.RATE;
    
                    const { minCount, maxCount } = this.calculateMinMaxCount(data.COUNT);
                    existingEntry.minCount = minCount;
                    existingEntry.maxCount = maxCount;
    
                    const updatedDeheadingRateData = await transactionManager.getRepository(DeheadingRatesEntity).save(existingEntry);
                    if (!updatedDeheadingRateData) {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new CommonResponse(false, 0, 'Something went wrong while updating deheading rates information');
                    }
                } else {
                    const deheadingRateObj = new DeheadingRatesEntity();
                    deheadingRateObj.contractorName = data.ContractorName;
                    deheadingRateObj.count = data.COUNT;
                    deheadingRateObj.billType = data.BILLTYPE;
                    deheadingRateObj.rate = data.RATE;
                    deheadingRateObj.contractorId = contractorId;
    
                    const { minCount, maxCount } = this.calculateMinMaxCount(data.COUNT);
                    deheadingRateObj.minCount = minCount;
                    deheadingRateObj.maxCount = maxCount;
    
                    const saveDeheadingRateData = await transactionManager.getRepository(DeheadingRatesEntity).save(deheadingRateObj);
                    if (!saveDeheadingRateData) {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new CommonResponse(false, 0, 'Something went wrong while saving deheading rates information');
                    }
                }
            }
    
            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new CommonResponse(true, 1, 'Data processed successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 0, 'Something went wrong');
            }
        } catch (err) {
            console.log(err, 'errrrrrrr');
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, 'Something went wrong');
        }
    }
    
    calculateMinMaxCount(count: string): { minCount: number, maxCount: number } {
        if (count.toLowerCase() === 'any') {
            return { minCount: 0, maxCount: 0 };
        } else if (count.toLowerCase().startsWith('below')) {
            const maxCount = parseInt(count.split(' ')[1], 10);
            return { minCount: 0, maxCount: maxCount || 0 };
        } else if (count.includes('-')) {
            const [min, max] = count.split('-').map(val => parseInt(val, 10));
            return { minCount: min || 0, maxCount: max || 0 };
        } else {
            const exactCount = parseInt(count, 10);
            return { minCount: exactCount || 0, maxCount: exactCount || 0 };
        }
    }


    async getAllDegeadingRatesData() : Promise<CommonResponse>{
        try{ 
            const manager = getManager()

               let query =`select  contractor_name as conractorName,count,bill_type as  billType, rate 
            FROM ${appSettings.masters_db}.deheading_rates `
            const result = await manager.query(query)

            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }

           }catch(err){
            throw(err)
           }
    }

}
